import React, { useEffect, useMemo, useRef } from 'react';
import TablePro from '@/components/TablePro';
import { connect, history } from 'umi';
import { exportproservcatgstat } from '@/_serveice/project';
import { downloadXlsx, splitParamsFoGet, toAmount } from '@/_util/util';
import { Button } from 'kenshin';
import './index.less';

const ServCatgStat = ({ project, systemOrgani, dispatch }) => {
  const columns = [
    {
      dataIndex: 'servCatgName',
      title: '工作包名称',
      width: 150,
    },
    {
      dataIndex: 'servCatgLeaderName',
      title: '负责人名称',
      width: 150,
    },
    {
      key: 'servCatgCount',
      title: '数量',
      width: 100,
      render(row) {
        return `${row.servCatgFinishNum}/${row.servCatgCount}`;
      },
    },
    {
      key: 'servCatgFinishAmount',
      title: '金额',
      width: 100,
      render(row) {
        return `${toAmount(row.servCatgFinishAmount)}/${toAmount(
          row.servCatgDiscTotalAmount,
        )}`;
      },
    },
    {
      dataIndex: 'servCatgUnitPrice',
      title: '原单价',
      width: 100,
      render: toAmount,
    },
    {
      dataIndex: 'servCatgOrginTotalAmount',
      title: '原总价',
      width: 100,
      render: toAmount,
    },
    {
      dataIndex: 'servCatgHourDiscCost',
      title: '优惠后单价',
      width: 100,
      render: toAmount,
    },
    {
      dataIndex: 'servCatgEstimatedOsAmount',
      title: '预估外包费用',
      width: 100,
      render: toAmount,
    },
    {
      dataIndex: 'servCatgActualOsAmount',
      title: '实际外包费用',
      width: 100,
      render: toAmount,
    },
    {
      dataIndex: 'servCatgPlanUnitAmount',
      title: '计划单位投入',
      width: 100,
    },
    {
      dataIndex: 'servCatgActualUnitAmount',
      title: '实际单位投入',
      width: 100,
    },
    {
      dataIndex: 'servCatgDifferenceUnitAmount',
      title: '计划与实际单位投入差额',
      width: 100,
    },
    {
      dataIndex: 'servCatgPercentageUnitAmount',
      title: '比例',
      width: 200,
      render(val) {
        let color = '#1890ff';
        if (val < 85) color = '#5bc49f';
        else if (val > 115) color = '#f5222d';
        return (
          <div className="process-col">
            <span className="process-text">{val}</span>
            <div className="process-bar">
              <div
                className="process-fill"
                style={{ width: `${val}%`, backgroundColor: color }}
              ></div>
            </div>
          </div>
        );
      },
    },
    {
      dataIndex: 'servCatgCostSave',
      title: '成本节约',
      width: 100,
    },
    {
      dataIndex: 'servCatgTeamList',
      title: '参与团队',
      width: 100,
      render(list) {
        return list?.join(',');
      },
    },
    {
      dataIndex: 'totalRptWorkHours',
      title: '总上报工时',
      width: 100,
      render: (val) => val ?? 0,
    },
  ];

  const extra = () => (
    <Button
      type="primary"
      onClick={() => {
        let payload = {
          projectId: history.location.query?.projectId ?? '',
        };
        let url = `${baseURL}${exportproservcatgstat}${splitParamsFoGet(
          payload,
        )}`;
        downloadXlsx(url, '工作包统计');
      }}
    >
      导出
    </Button>
  );

  return (
    <div className="serv-catg-stat">
      <TablePro
        params={{ projectId: history.location.query?.projectId }}
        request="project/getProServCatgstatList"
        rowKey="proServCatgId"
        columns={columns}
        pagination={false}
        extra={extra}
        scrollX
        columnsOptions={false}
        curColumns
        dataSource={project.proServCatgstatList}
      />
    </div>
  );
};

export default connect(({ project, systemOrgani }) => {
  return {
    project,
    systemOrgani,
  };
})(ServCatgStat);
